import { ArrowLeft } from "lucide-react";

export default function TermsPage({ onBack }) {
  return (
    <div className="min-h-screen bg-[#F8FAFC] p-6" data-testid="terms-page">
      <div className="max-w-2xl mx-auto">
        <button onClick={onBack} className="flex items-center gap-2 text-green-700 hover:text-green-800 text-sm font-semibold mb-6" data-testid="terms-back">
          <ArrowLeft className="w-4 h-4" /> Torna indietro
        </button>
        <div className="bg-white border border-slate-200 rounded-2xl p-8 shadow-sm">
          <h1 className="text-2xl font-bold text-slate-800 mb-6">Termini di Servizio</h1>
          <div className="prose prose-sm prose-slate max-w-none space-y-4 text-slate-600">
            <p><strong>Fornitore del servizio:</strong> AC Digital App</p>
            <p><strong>Sito:</strong> https://gestionepassword.it</p>
            <h2 className="text-lg font-semibold text-slate-800 mt-6">1. Descrizione del servizio</h2>
            <p>Gestione Password e' un'applicazione web per la gestione sicura di credenziali personali. Il servizio e' disponibile in versione gratuita (Free) e premium (Premium).</p>
            <h2 className="text-lg font-semibold text-slate-800 mt-6">2. Piano Free</h2>
            <p>Il piano gratuito consente la memorizzazione di un massimo di 10 password. Per password illimitate e' necessario il piano Premium.</p>
            <h2 className="text-lg font-semibold text-slate-800 mt-6">3. Responsabilita'</h2>
            <p>L'utente e' responsabile della sicurezza delle proprie credenziali di accesso. AC Digital App non e' responsabile per accessi non autorizzati dovuti a negligenza dell'utente nella custodia della password principale.</p>
            <h2 className="text-lg font-semibold text-slate-800 mt-6">4. Disponibilita' del servizio</h2>
            <p>Il servizio viene fornito "cosi' com'e'" senza garanzia di disponibilita' ininterrotta. AC Digital App si impegna a garantire la massima operativita' ma non puo' garantire l'assenza di interruzioni.</p>
            <h2 className="text-lg font-semibold text-slate-800 mt-6">5. Cancellazione account</h2>
            <p>L'utente puo' richiedere la cancellazione del proprio account e di tutti i dati associati contattando: acdigital.app@gmail.com</p>
            <h2 className="text-lg font-semibold text-slate-800 mt-6">6. Modifiche ai termini</h2>
            <p>AC Digital App si riserva il diritto di modificare questi termini. Le modifiche saranno comunicate tramite il sito web.</p>
            <h2 className="text-lg font-semibold text-slate-800 mt-6">7. Legge applicabile</h2>
            <p>Questi termini sono regolati dalla legge italiana. Per qualsiasi controversia sara' competente il foro di residenza dell'utente consumatore.</p>
          </div>
        </div>
      </div>
    </div>
  );
}
